/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconEvent/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconEvent({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconEvent",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 12,
  fill = "#323F4B",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconEvent.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 12"
 style={{'--as-1-RuH2D': alignSelf,'--mt-2-RuH2D': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-RuH2D': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-RuH2D': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-RuH2D': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-RuH2D': opacity,'--w-10-RuH2D': typeof width === 'number' ? `${width}px` : width,'--h-11-RuH2D': typeof height === 'number' ? `${height}px` : height,'--f-12-RuH2D': fill,'--a-7-RuH2D': isAnimated ? animation : "none",'--sd-8-RuH2D': isAnimated ? strokeDashoffset : 0,'--sd-9-RuH2D': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2IconEvent.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_14073_3416)"
 className="views-block"
>
<path
  data-testid="Tysiav2IconEvent.SvgPath"
  data-view-path={viewPath}
 clipRule="evenodd"
 d="M2.75.5c.434 0 .786.352.786.786v.785h3.928v-.785a.786.786 0 011.572 0v.785h.785C10.472 2.071 11 2.6 11 3.25v7.071c0 .651-.528 1.179-1.179 1.179H1.18C.528 11.5 0 10.972 0 10.321V3.25c0-.65.528-1.179 1.179-1.179h.785v-.785c0-.434.352-.786.786-.786zm-.393 4.518a.196.196 0 00-.196.196v2.357c0 .109.088.197.196.197h2.357a.196.196 0 00.197-.197V5.214a.196.196 0 00-.197-.196H2.357z"
 className="views-block"
/>
</g>
</svg>
{children}
</React.Fragment>)
}